import api from '@/api'

const namespaced = true

const state = {
  OEEItemsManagement: [],
  OEEItemsManagementFiles: null
}

const getters = {
  OEEItemsManagement: state => state.OEEItemsManagement,
  OEEItemsManagementFiles: state => state.OEEItemsManagementFiles
}

const mutations = {
  SET_OEE_ITEMS_MANAGEMENT: (state, payload) => {
    state.OEEItemsManagement = payload
  },
  SET_OEE_ITEMS_MANAGEMENT_FILES: (state, payload) => {
    state.OEEItemsManagementFiles = payload
  }
}

const actions = {
  async fetchOEEItemsManagement({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search || null,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 10,
        ...payload
      }
      const { data } = await api.getOEEItems(filter)
      if (data.error) {
        commit('SET_OEE_ITEMS_MANAGEMENT', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }
      if (!data.data) {
        commit('SET_OEE_ITEMS_MANAGEMENT', data)
        return
      }
      commit('SET_OEE_ITEMS_MANAGEMENT', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },

  async postOEEItem(_, payload) {
    try {
      const data = await api.postOEEItem(payload);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async putOEEItem(_, payload) {
    try {
      const data = await api.putOEEItem(payload.id, payload.form);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async deleteOEEItem(_, payload) {
    try {
      const data = await api.deleteOEEItem(payload);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async downloadOEEItemsManagement({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getOEEItemExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_OEE_ITEMS_MANAGEMENT_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },

  async resetOEEItemsManagementFiles({ commit }) {
    commit('SET_OEE_ITEMS_MANAGEMENT_FILES', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
